import { ButtonPosition } from '../../position/button-position';
import { executeObjectExpr, executeFunction } from '@/common/util/util';
import isPlainObject from 'lodash/isPlainObject';
import { CnMenuButton, CnMenuButtonItem } from '@cainiaofe/cn-ui';
export const config = {
    value: 'buttonGroup',
    position: [ButtonPosition.tableBatchArea, ButtonPosition.tableToolArea],
    getRenderDom: (config) => {
        const { children, options = {}, position, selectedRowKeys, selectedRowRecords, makeButton, buttonConfig, } = config;
        const { buttonList } = options;
        const menu = [];
        if (Array.isArray(buttonList) && buttonList.length > 0 && makeButton) {
            buttonList.forEach((item, index) => {
                const tempButton = makeButton(item, position, {
                    buttonProps: {
                        text: true,
                    },
                });
                if (tempButton) {
                    const { disabled, onClick } = tempButton;
                    if (isPlainObject(tempButton) && onClick) {
                        const isDisabled = executeObjectExpr(disabled, {}, selectedRowKeys);
                        menu.push(<CnMenuButtonItem key={index} disabled={isDisabled} onClick={onClick.bind(this, selectedRowKeys, selectedRowRecords)}>
                {tempButton.children}
              </CnMenuButtonItem>);
                    }
                    else if (typeof tempButton === 'function') {
                        const tempButton2 = executeFunction(tempButton, selectedRowKeys, selectedRowRecords, { text: true });
                        if (tempButton2) {
                            menu.push(<CnMenuButtonItem key={index}>{tempButton2}</CnMenuButtonItem>);
                        }
                    }
                }
            });
        }
        return (<CnMenuButton {...buttonConfig} autoWidth={false} popupProps={{ cache: true }} label={children}>
        {menu}
      </CnMenuButton>);
    },
    action: () => { },
};
